import React, {Suspense} from "react";
import {observer} from "mobx-react-lite";
import {FilePondInitialFile} from "filepond";
import CommonUtil from "utils/CommonUtil";
import ObjectUtil from "utils/ObjectUtil";
import {
    DeleteFileType,
    FileType,
    RaonKUploadDelFile,
    RaonKUploadNewFile,
    UIRaonKFileUploadProps
} from "../../types/KFileUploadType";
import TbComFileMapngDetail from "../../domain/main/com/file/mapng/TbComFileMapngDetail";
import {DataJobTypes} from "../../domain/BaseEntity";
import TbComFile from "../../domain/main/com/file/TbComFile";
import PageLoading from "../loading";
import usePromise from "common/hooks/usePromise";


function UIRaonKFileUpload(props: UIRaonKFileUploadProps) {
    const RAONKUPLOAD = window["RAONKUPLOAD"];
    const RAONKUpload = window["RAONKUpload"];

    const [uploadId] = React.useState("RaonK" + CommonUtil.getUid());
    const [rowAdded, setRowAdded] = React.useState(false);

    const attrs: any = {...props.attrs};
    attrs.Width = ObjectUtil.defaultIfNull(attrs.Width, "100%");
    attrs.Height = ObjectUtil.defaultIfNull(attrs.Height, "200px");
    attrs.ExtensionAllowOrLimit = ObjectUtil.defaultIfNull(attrs.ExtensionAllowOrLimit, "1");
    attrs.ExtensionArr = ObjectUtil.defaultIfNull(attrs.ExtensionArr, "pptx,ppt,pdf,doc,docx,xls,xlsx,hwp,hwpx,zip,gif,jpg,jpeg,png");
    attrs.ButtonBarEdit = ObjectUtil.defaultIfNull(attrs.ButtonBarEdit, "add,remove,remove_all,download");
    attrs.MaxTotalFileCount = ObjectUtil.defaultIfNull(attrs.MaxTotalFileCount, "0");
    attrs.MaxOneFileSize = ObjectUtil.defaultIfNull(attrs.MaxOneFileSize, "0");
    attrs.MaxTotalFileSize = ObjectUtil.defaultIfNull(attrs.MaxTotalFileSize, "0");
    attrs.ImgPreView = ObjectUtil.defaultIfNull(attrs.ImgPreView, "0");
    attrs.ImgPreViewWidth = ObjectUtil.defaultIfNull(attrs.ImgPreViewWidth, "250px");
    attrs.ImgPreViewHeight = ObjectUtil.defaultIfNull(attrs.ImgPreViewHeight, "250px;");
    attrs.Views = ObjectUtil.defaultIfNull(attrs.Views, "list");

    const updatePropsValue = (uploadID: string, paramObj: FileType) => {
        const fileCount = RAONKUPLOAD.GetTotalFileCount(uploadID);
        const files: FilePondInitialFile[] = [];
        for (let i = 0; i < fileCount; i++) {
            files.push({
                source: paramObj.strName,
                options: {
                    type: 'input',
                    file: undefined,
                    metadata: undefined
                }
            } as FilePondInitialFile);
        }
        if (props.value)
            props.value.files = files;
    };

    const onAfterAddFileHandle = (uploadID: string, paramObj: FileType) => {
        updatePropsValue(uploadID, paramObj);
        props.onAfterAddFile && props.onAfterAddFile(uploadID, paramObj);
    };

    const onAfterDeleteFileHandle = (uploadID: string, paramObj: DeleteFileType) => {
        updatePropsValue(uploadID, paramObj);
        props.onAfterDeleteFile && props.onAfterDeleteFile(uploadID, paramObj);
    };

    const onUploadCompleteHandle = (uploadID: string) => {
        try {
            // 업로드가 완료된 상태에서 정상적인 업로드 결과 추출
            // K Upload는 array, json, xml, text delimit 방식으로 결과값을 제공합니다.
            const dataArray: {
                newFile: RaonKUploadNewFile[];
                deleteFile: RaonKUploadDelFile[];
                mergeFile: any[];
                webFile: any[]
            } = RAONKUPLOAD.GetListInfo(
                "array",
                uploadID
            );

            const tbComFileMapngDetailList: TbComFileMapngDetail[] = [];

            dataArray.newFile?.forEach((newFile, index) => {
                const tbComFileMapngDetail = new TbComFileMapngDetail();
                tbComFileMapngDetail.JOB_TYPES = DataJobTypes.CREATE;
                tbComFileMapngDetail.setFileDetailId(ObjectUtil.undefined);
                tbComFileMapngDetail.setFilePolicy("raonk");
                tbComFileMapngDetail.setFileRpstr("raonk");
                tbComFileMapngDetail.setStrePath("/" + newFile.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/"));
                tbComFileMapngDetail.setStreFileNm(newFile.uploadName);
                tbComFileMapngDetail.setOrginlFileNm(newFile.originalName);
                tbComFileMapngDetail.setFileExtsn(newFile.extension);
                tbComFileMapngDetail.setFileSize(newFile.size);
                tbComFileMapngDetail.setDwldId(ObjectUtil.undefined);
                tbComFileMapngDetail.setSortOrdr(index + 1);
                tbComFileMapngDetailList.push(tbComFileMapngDetail);
            });

            dataArray.deleteFile?.forEach((delFile) => {
                const tbComFileMapngDetail = new TbComFileMapngDetail();
                tbComFileMapngDetail.JOB_TYPES = DataJobTypes.DELETE;
                tbComFileMapngDetail.setFileDetailId(delFile.uniqKey);
                tbComFileMapngDetailList.push(tbComFileMapngDetail);
            });
            const tbComFile = props.value || new TbComFile();
            tbComFile.setTbComFileMapngDetailList(tbComFileMapngDetailList);
            props.valueChanged && props.valueChanged(tbComFile);

            props.onUploadComplete && props.onUploadComplete(uploadID);

            // RAONKUPLOAD.TransferByIndex();
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    const onUploadingCancelHandle = (uploadID: string, paramObj: Array<{
        originName: string;
        fileSize: number;
        uploadName: string;
        uploadPath: string;
        order: number;
    }>) => {
        try {
            if (typeof RAONKUPLOAD.promiseFunctions?.reject === "function") {
                RAONKUPLOAD.promiseFunctions.reject();
            }
            props.onUploadingCancel && props.onUploadingCancel(uploadID, paramObj);
        } catch (e) {
            console.error(e);
            throw e;
        }

    };

    const onErrorHandle = (uploadID: string, paramObj: {
        strCode: string;
        strMessage: string;
        arrUploadedFileList: Array<{
            originName: string;
            fileSize: number;
            uploadName: string;
            uploadPath: string;
            order: number;
        }>;
    }) => {
        try {
            if (typeof RAONKUPLOAD.promiseFunctions?.reject === "function") {
                RAONKUPLOAD.promiseFunctions.reject();
            }
            console.error("RAONKUpload", "Upload", uploadID, paramObj);
            props.onError && props.onError(uploadID, paramObj)
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    /*
        RAONKUPLOAD.MultiTransferCustom = () => {
            try {
                const uploadInfoMap: {
                    [uploadId: string]: { value: TbComFile, valueChanged: (value: TbComFile) => {} }
                } = RAONKUPLOAD.uploadInfoMap;
                const uploadIdList: string[] = [];

                for (const uploadId in uploadInfoMap) {
                    uploadIdList.push(uploadId);
                }

                if (uploadIdList.length > 0) {
                    RAONKUPLOAD.uploadIdList = uploadIdList;
                    RAONKUPLOAD.TransferByIndex(0);
                } else {
                    if (typeof RAONKUPLOAD.promiseFunctions?.resolve === "function") {
                        RAONKUPLOAD.promiseFunctions.resolve();
                    }
                }
            } catch (e) {
                console.error(e);
                throw e;
            }
        };


        RAONKUPLOAD.TransferByIndex = (index?: number) => {
            try {
                if (index == null) {
                    index = ++RAONKUPLOAD.uploadTransferIndex || 0;
                }

                if (RAONKUPLOAD.uploadIdList.length > index) {
                    const uploadId = RAONKUPLOAD.uploadIdList[index];

                    RAONKUPLOAD.uploadTransferIndex = index;
                    RAONKUPLOAD.Transfer(uploadId);
                } else {
                    if (typeof RAONKUPLOAD.promiseFunctions?.resolve === "function") {
                        RAONKUPLOAD.promiseFunctions.resolve();
                    }
                }
            } catch (e) {
                console.error(e);
                throw e;
            }
        };
    */
    const [raonKUploadLoading, raonKUploadResolved] = usePromise(() => new Promise<any>((resolve, reject) => {
        const onCreationCompleteHandler = (uploadId: string) => {
            if (props?.onCreationComplete) {
                props?.onCreationComplete(uploadId)
            }
            resolve(newRAONKUpload);
        }

        const newRAONKUpload = new RAONKUpload({
            Id: uploadId,
            UploadHolder: uploadId,
            IgnoreSameUploadName: "0",
            Width: attrs.Width,
            Height: attrs.Height,
            ImgPreView: attrs.ImgPreView,
            ImgPreViewWidth: attrs.ImgPreViewWidth,
            ImgPreViewHeight: attrs.ImgPreViewHeight,
            // 기본값 : list, 썸네일 : thumbs
            Views: attrs.Views,
            // 전체 파일 사이즈 체크: 기본값: 0  제한없음, B(byte), KB(kilobyte), MB(megabyte), GB(gigabyte)
            MaxTotalFileSize: attrs.MaxTotalFileSize,
            // 파일별 파일 사이즈 체크:
            MaxOneFileSize: attrs.MaxOneFileSize,
            // 업로드할 최대 파일 개수 (0 : 제한없음)
            MaxTotalFileCount: attrs.MaxTotalFileCount,
            // 특정 확장자만 업로드 허용할 경우 : 1, 제외할 경우 : 0
            ExtensionAllowOrLimit: attrs.ExtensionAllowOrLimit,
            // 특정 확장자만 체크시, 콤마 구분
            ExtensionArr: attrs.ExtensionArr,
            Mode: "edit", // edit, view
            ButtonBarEdit: attrs.ButtonBarEdit,
            UseAlertEvent: attrs.UseAlertEvent,
            SimpleUIMode: attrs.SimpleUIMode,
            SilentUpload: attrs.SilentUpload,
            SilentDownload: attrs.SilentDownload,
            SkinName: attrs.SkinName,
            Event: {
                OnError: onErrorHandle,
                CreationComplete: onCreationCompleteHandler,
                BeforeUpload: props?.onBeforeUpload,
                UploadComplete: onUploadCompleteHandle,
                MultiUploadComplete: props?.onMultiUploadComplete,
                BeforeOpenFile: props?.onBeforeOpenFile,
                BeforeAddFile: props?.onBeforeAddFile,
                AfterAddFile: onAfterAddFileHandle,
                AfterAddAllFile: props?.onAfterAddAllFile,
                BeforeDeleteFile: props?.onBeforeDeleteFile,
                AfterDeleteFile: onAfterDeleteFileHandle,
                DeleteAllFile: props?.onDeleteAllFile,
                SelectItem: props?.onSelectItem,
                AfterMoveFile: props?.onAfterMoveFile,
                UploadingCancel: onUploadingCancelHandle,
                CustomAction: props?.onCustomAction,
                OnLanguageDefinition: props?.onLanguageDefinition,
                Alert: props?.onAlert
            }
        });

        if (RAONKUPLOAD.uploadInfoMap == null) {
            RAONKUPLOAD.uploadInfoMap = {};
        }
        RAONKUPLOAD.uploadInfoMap[uploadId] = {value: props.value, valueChanged: props.valueChanged};
    }), [])

    React.useEffect(() => {
        return () => {
            if (raonKUploadResolved) {
                RAONKUPLOAD.Destroy(raonKUploadResolved.ID)
            }
        }
    }, [raonKUploadResolved]);

    React.useEffect(() => {
        if (!raonKUploadLoading && props.value?.tbComFileMapngDetailList) {
            props.value?.tbComFileMapngDetailList?.forEach(tbComFileMapngDetail => {
                console.log("AddUploadedFile",
                    tbComFileMapngDetail.getFileDetailId(),
                    tbComFileMapngDetail.getOrginlFileNm(),
                    tbComFileMapngDetail.getStrePath() + "/" + tbComFileMapngDetail.getStreFileNm(),
                    tbComFileMapngDetail.getFileSize(),
                    "raonk",
                    uploadId
                )
                RAONKUPLOAD.AddUploadedFile(
                    tbComFileMapngDetail.getFileDetailId(),
                    tbComFileMapngDetail.getOrginlFileNm(),
                    tbComFileMapngDetail.getStrePath() + "/" + tbComFileMapngDetail.getStreFileNm(),
                    tbComFileMapngDetail.getFileSize(),
                    "raonk",
                    uploadId
                );
            });
        }
    }, [raonKUploadLoading, props.value?.tbComFileMapngDetailList])

    return (
        <Suspense fallback={<PageLoading/>}>
            <div id={uploadId} className={props.className}></div>
        </Suspense>
    );
}

export default observer(UIRaonKFileUpload);

